import { getAccount } from "service/auth";

export function useGetMsalUserEmail() {
  const userAccount = getAccount();
  const email = userAccount?.idToken?.emails[0];
  return email;
}
